<agm-map [latitude]="lat" [longitude]="lng" [zoom]="15" style="height: 100%">
  <agm-marker
    [latitude]="markerLat"
    [longitude]="markerLng"
    (dragEnd)="onMapDragEnd($event)"
    [markerDraggable]="true"
  ></agm-marker>
</agm-map>
